import { VendorLocationsListVendor } from '../../components/Vendor';
import { usePageTitle } from '../../hooks';

export function Locations() {
  usePageTitle('vendor:location.title');
  return <VendorLocationsListVendor />;
}
